<app-login-layout class="app-light-theme">
  <main class="ata-auth-page ata-auth-page--forgot">
    <header class="ata-auth-topbar">
      <a class="ata-auth-brand" routerLink="/auth">
        <span class="ata-auth-brand__mark">A</span>
        <span class="ata-auth-brand__name">Auto Transport Alliance</span>
      </a>

      <nav class="ata-auth-nav">
        <a class="ata-auth-nav__link" routerLink="/auth">Log In</a>
        <a class="ata-auth-nav__link" routerLink="/register">Registration</a>
        <a class="ata-auth-nav__link is-active" routerLink="/forgot-password">Forgot Password</a>
      </nav>
    </header>

    <section class="ata-auth-hero">
      <div class="ata-auth-hero__visual">
        <img src="assets/image/auth-hero-bg.jpg" alt="Password reset assistance background" />
      </div>
      <div class="ata-auth-hero__overlay"></div>

      <div class="ata-auth-hero__inner">
        <div class="ata-auth-grid">
          <aside class="ata-auth-info">
            <div>
              <p class="ata-auth-info__eyebrow">Recovery</p>
              <h1 class="ata-auth-info__title">Reset your account access.</h1>
              <p class="ata-auth-info__copy">
                Submit your registered email and we will send a secure reset link to recover your account.
              </p>

              <div class="ata-auth-info__list">
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Flow</p>
                  <p class="ata-auth-info__value">Request reset link, verify token, and set a new password.</p>
                </div>
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Support</p>
                  <p class="ata-auth-info__value">If you do not receive an email, confirm address spelling and retry.</p>
                </div>
              </div>
            </div>

            <p class="ata-auth-info__badge">Page 03</p>
          </aside>

          <section class="ata-auth-card">
            <p class="ata-auth-card__eyebrow">Password Recovery</p>
            <p class="ata-auth-card__intro">Enter your email to receive a reset link.</p>

            <div *ngIf="success; else forgotForm" class="forgot-success">
              <h2>Check your inbox</h2>
              <p>Email with reset password link successfully sent.</p>
              <button type="button" class="login__form--button" mat-raised-button color="primary" (click)="navigateToLogin()">
                Back to Login
              </button>
            </div>

            <ng-template #forgotForm>
              <form class="forgot-form">
                <h2>Forgot Password</h2>
                <h5>Account recovery for carrier access.</h5>

                <div class="mb-3">
                  <mat-form-field>
                    <input [formControl]="email" type="email" matInput placeholder="Enter your email" />
                  </mat-form-field>
                </div>

                <div class="mb-3 text-center mt-3">
                  <button type="button" [disabled]="email.invalid" (click)="forgot()" class="login__form--button"
                    mat-raised-button color="primary">
                    Submit
                  </button>
                </div>

                <div class="mb-3 mt-3 register-here">
                  <p textSize="13">
                    Don’t have an Account?
                    <span textSize="14" class="block--click" (click)="navigateToRegister()">
                      Register Here
                    </span>
                  </p>
                </div>
              </form>
            </ng-template>
          </section>
        </div>
      </div>
    </section>
  </main>
</app-login-layout>
